import { appendIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'

import { checklistsClient } from '../../../../utils/apollo/api'
import { cleanRequest } from './cleanRequest'
import { useCloseModal, useModalData } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertChecklist($input: ChecklistInput, $toTemplates: Boolean, $templatesProjectId: Int) {
    insertChecklist(input: $input, toTemplates: $toTemplates, templatesProjectId: $templatesProjectId) {
      id
    }
  }
`

const validate = (form, setErrors, toTemplates) => {
  const errors = [
    ...appendIf(!form.name, { path: ['name'], message: 'Campo obrigatório' }), //
    ...appendIf(toTemplates && !form.templatesProject?.id, { path: ['templatesProject'], message: 'Campo obrigatório' }) //
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useCloneChecklist = () => {
  const notify = useNotification()
  const closeModal = useCloseModal()
  const { toTemplates } = useModalData()

  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Checklists'], client: checklistsClient })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)
    const { setErrors } = actions
    const isValid = validate(form, setErrors, toTemplates)

    if (isValid) {
      return request({ variables: { input, toTemplates, templatesProjectId: form.templatesProject?.id } }).then(
        resp => {
          if (!resp.errors) {
            notify.success({ title: 'Questionário clonado com sucesso' })
            closeModal()
          } else {
            notify.error({ title: 'Ocorreu um erro ao clonar o checklist' })
          }
        }
      )
    }
  }

  return [handleRequest, state]
}
